import { Upload } from 'antd'
import clsx from 'clsx'
import { type ReactNode, type FC } from 'react'
import { AiOutlineInbox } from 'react-icons/ai'

import { ACTIONS } from '@/constants/common/message.constants'

import { type UseFileUploadProps, useFileUpload } from '../../hooks'
import { type UploadFileResult } from '../../models'

import styles from './FileUploadDragger.module.scss'

type FileUploadDraggerProps = Omit<UseFileUploadProps, 'multiple'> & {
  value?: UploadFileResult
  className?: string
  title?: ReactNode
  description?: ReactNode
  validateError?: boolean
}

/**
 * ファイルアップロード用のComponent
 * - 選択 または ドラッグ&ドロップでファイルをアップロード
 * - 単一ファイルのみアップロード可能
 * - アップロードが成功すれば onChangeUploadFile から S3にアップロードされた fileKey と fileName が受け取れる
 */
export const FileUploadDragger: FC<FileUploadDraggerProps> = ({
  title = ACTIONS.SELECT_FILE,
  description,
  className,
  validateError,
  ...props
}) => {
  const {
    fileList,
    errorMessage,
    uploadRequest,
    beforeUpload,
    onUploadChange,
    onDelete
  } = useFileUpload(props)

  return (
    <div>
      <Upload.Dragger
        data-testid="file-upload-dragger"
        multiple={false}
        customRequest={uploadRequest}
        beforeUpload={beforeUpload}
        className={clsx([
          className,
          validateError && 'validate-error',
          styles.container
        ])}
        maxCount={1}
        fileList={fileList}
        onChange={onUploadChange}
        onRemove={onDelete}
      >
        <div className="mb-4 flex justify-center">
          <AiOutlineInbox size={48} className="text-primary" />
        </div>
        <div className="text-center text-black">
          <div className="text-[15px]">{title}</div>
          {description && (
            <div className="mt-1 text-sm text-secondary">{description}</div>
          )}
        </div>
      </Upload.Dragger>
      {errorMessage && (
        <div className="pt-1 text-xs text-red">{errorMessage}</div>
      )}
    </div>
  )
}
